import { Fragment } from 'react';
import { createFileRoute, useParams } from '@tanstack/react-router'
import CompetitionSponsors from '@/components/Competition/CompetitionSponsors';
import CompetitionPrizes from '@/components/Competition/CompetitionPrizes';
// import CompetitionMembers from '@/components/Competition/CompetitionMembers';
import CompetitionDetails from '@/components/Competition/CompetitionDetails';
import BackTo, { BACKTO_HEIGHT } from '@/components/BackTo';
//import styles from './competition.module.css';

export const Route = createFileRoute('/competition/$competitionId')({
  component: CompetitionDetailPage,
})

const logRoute = (id: string) => {
  console.log("Competition route: ", id);
}

function CompetitionDetailPage() {
    const { competitionId } = useParams({ from: '/competition/$competitionId' });
    const backRoute = `/leaderboard/${competitionId}`;
    const scrollViewStyles = {
      height: `calc(100% - ${BACKTO_HEIGHT})`
    }
    logRoute(competitionId);

    return (
      <Fragment>
        <BackTo route={backRoute} label="Back to leaderboard" />
        <div className="scrolling-container" style={scrollViewStyles}>
          <div className="outer-container">
              <CompetitionDetails competitionId={competitionId} />
              <CompetitionPrizes competitionId={competitionId} />
              <CompetitionSponsors competitionId={competitionId} />
              { /*
              <CompetitionMembers title="Judges" competitionId={competitionId} role={PersonRole.JUDGE} />
              <CompetitionMembers title="Competitors" competitionId={competitionId} role={PersonRole.COMPETITOR} />
              */ }
            </div>
        </div>
      </Fragment>
    )
}
